export default "__VITE_ASSET__CazZgqf0__"